import React from 'react';
import ReactDOM from 'react-dom';

import DefectCategory from '../src/components/defect_category';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('defect-category-mount-point');
  const defectCategoryId = element.dataset.id;
  ReactDOM.render(<DefectCategory defectCategoryId={defectCategoryId} summary={false} />, element);
})
